import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  managePaymentContainer: {
    display: 'flex',
    flex: '1',
    padding: '0px',
    backgroundColor: theme.evPalette.charcoal[100],
    flexDirection: 'column',
    '@media (min-width: 640px)': {
      padding: '16px 24px',
      flexDirection: 'row',
      gap: '16px',
    },
  },
  prePaymentBox: {
    display: 'flex',
    flex: '1 1 auto',
    height: 'fit-content',
    flexDirection: 'column',
    '@media (min-width: 640px)': {
      gap: '15px',
    },
  },
  prePaymentPaper: {
    display: 'flex',
    flex: 'none',
    flexDirection: 'column',
    borderRadius: '0px',
    height: 'fit-content',
    padding: '24px',
    gap: '24px',
    borderBottom: `1px solid ${theme.evPalette.charcoal[400]}`,
    '@media (min-width: 640px)': {
      flex: '1 1 auto',
      borderRadius: '4px',
    },
  },
  prePaymentPaperContent: {
    display: 'flex',
    flex: '1 1 auto',
    flexDirection: 'column',
    height: 'fit-content',
    gap: '16px',
    '@media (min-width: 640px)': {
      borderRadius: '4px',
    },
  },
  reminderBox: {
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
    padding: '16px',
    backgroundColor: theme.evPalette.mango[100],
    '@media (min-width: 640px)': {
      borderRadius: '4px',
    },
  },
  currentLevelBox: {
    display: 'flex',
    flexDirection: 'column',
    padding: '16px',
    borderRadius: '4px',
    gap: '8px',
    backgroundColor: theme.evPalette.charcoal[100],
    '@media (min-width: 640px)': {
    },
  },
  prePaymentOptionBox: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    flexDirection: 'row',
    height: 'fit-content',
    gap: '24px',
    '@media (min-width: 640px)': { gap: '48px' },
  },
  inputBox: {
    display: ' flex',
    alignItems: 'center',
    gap: '8px',
    width: '120px',
    '@media (min-width: 640px)': { width: '235px' },
  },
  membershipLevelContainer: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '0px',
    height: 'fit-content',
    padding: '24px',
    gap: '16px',
    flex: '1 1 0',
    '@media (min-width: 640px)': {
      borderRadius: '4px',
      gap: '24px',
      minWidth: '430px',
      flex: 0,
    },
  },
  membershipLevelContentBox: {
    display: 'flex',
    flexDirection: 'column',
    height: 'fit-content',
    padding: '0px',
    '@media (min-width: 640px)': {
      borderRadius: '4px',
      gap: '8px',
    },
  },
  membershipLevelContent: {
    display: 'flex',
    flexDirection: 'row',
    height: 'fit-content',
    padding: '0px',
    '@media (min-width: 640px)': {
      borderRadius: '4px',
    },
  },
  membershipLevelLink: {
    color: theme.evPalette.ocean[600],
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    textDecoration: 'underline',
    fontWeight: 400,
    lineHeight: '24px',
    textAlign: 'left',
    margin: 'auto 0px auto 0px',
    '@media (max-width: 790px)': {
      marginLeft: '0px',
    },
  },
  upgradeBox: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '4px',
    backgroundColor: theme.evPalette.ocean[100],
    padding: '10px',
    gap: '16px',
    '@media (min-width: 640px)': {
    },
  },
  sleletonBox: {
    display: 'flex',
    flex: '1 1 auto',
    flexDirection: 'column',
    height: 'fit-content',
    padding: '24px',
    gap: '16px',
    borderRadius: '0px',
    borderBottom: `1px solid ${theme.evPalette.charcoal[400]}`,
    '@media (min-width: 640px)': {
      borderRadius: '4px',
      padding: '24px',
      gap: '16px',
    },
  },
  value: {
    marginLeft: 'auto',
  },
  button: {
    width: '100%',
    height: '44px',
    '@media (min-width: 640px)': {
      width: 'fit-content',
    },
  },
  buttonSkeleton: {
    height: '44px',
    width: '100%',
    borderRadius: '6px',
    '@media (min-width: 640px)': {
      width: '10%',
    },
  },
  textField: {
    height: '100%',
    '&>.myev-MuiInputBase-root': {
      height: '44px',
    },
  },
  customMembershipBox: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '0px',
    height: 'fit-content',
    padding: '16px',
    gap: '24px',
    backgroundColor: theme.evPalette.charcoal[100],
    '@media (min-width: 640px)': {
      borderRadius: '4px',
    },
  },
  customMembershipContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  customMembershipSubContent: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
  },
  amountInputHelperText: {
    color: `${theme.evPalette.rose[900]} !important`,
    margin: '0px',
    display: 'block',
  },
}));
